// /admin — the operator's tenant list. Cross-tenant, so it hangs off
// `_admin`, not `_shell`.

import { createRoute } from "@tanstack/react-router";
import { adminRoute } from "./_admin";
import { AdminConsoleScreen } from "../screens/admin/AdminConsoleScreen";

export const adminConsoleRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/admin",
  staticData: { title: "Tenants" },
  component: AdminConsoleScreen,
});
